import { useEffect, useState } from 'react'
import { languageUtil, onLanguageChange } from '../../util/languageUtils'

const LanguageSwitchButton = () => {
    const { language, setLanguage } = languageUtil()
    const [currentLang, setCurrentLang] = useState(language)

    useEffect(() => {
        const unsubscribe = onLanguageChange(setCurrentLang)
        return () => unsubscribe()
    }, [])

    const toggleLanguage = () => {
        const newLang = currentLang === 'en' ? 'ar' : 'en'
        setLanguage(newLang)
    }

    return (
        <button onClick={toggleLanguage} className='text-sm bg-transparent rounded '>
            <img
                src={currentLang === 'en' ? '/img/lang/GB.png' : '/img/lang/SA.png'}
                className='w-8'
            />
        </button>
    )
}

export default LanguageSwitchButton
